module.exports = __webpack_public_path__ + "img/it.cc6e41d1.svg";